import { MutationTree } from 'vuex';
import { IEngagementVideo } from '../types/engagement-video';
import { EEngagementVideoMutation } from './engagement-video.constants';
import { IEngagementVideoState } from './engagement-video.types';

export const mutations: MutationTree<IEngagementVideoState> = {
  [EEngagementVideoMutation.SetAdding](state: IEngagementVideoState, adding: boolean) {
    state.adding = adding;
  },
  [EEngagementVideoMutation.SetState](
    state: IEngagementVideoState,
    newState: IEngagementVideoState
  ) {
    Object.assign(state, newState);
  },
  [EEngagementVideoMutation.SetVideo](state: IEngagementVideoState, video: IEngagementVideo) {
    state.addedVideo = video;
  },
};
